import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { IBloodProductAdministrationState } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.types'
import { getBloodProductAdministrationSelector } from '../../procedures/bloodProductAdministration/selectors/bloodProductAdministration.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* addBloodProductAdministrationItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)

  const { items } = timeline
  const bloodProductAdministrationState: IBloodProductAdministrationState = yield select(
    getBloodProductAdministrationSelector
  )
  const { pta, addToTimeline, key, time, date, assessedBy, comments, bloodProduct, ptIdVerified } =
    bloodProductAdministrationState

  try {
    if (addToTimeline) {
      const assessedByLabel = assessedBy?.name || ''
      const bloodProductName = bloodProduct?.name || ''
      const ptIdVeirfiedName = ptIdVerified?.name || ''
      const index = items.findIndex((item) => item.key === key)
      const dateTime = new Date(date || 0)
      if (time) {
        if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
        dateTime.setMinutes(+time.split(':')[1])
        dateTime.setHours(+time.split(':')[0])
      }

      const item: IItem = {
        key: key,
        grid: true,
        labelHeaderFlag: pta ? 'PTA' : '',
        labelHeader: time,
        subHeader: date,
        itemType: 'Procedures',
        event: TimelineConstants.BLOOD_PRODUCT_ADMINISTRATION_PROCEDURE,
        eventSubHeader: `By ${assessedByLabel},
      Blood Product: ${bloodProductName}, PT. Id Verified: ${ptIdVeirfiedName}, Comments: ${comments}.`,
        rowActionType: TimelineConstants.SET_BLOOD_PRODUCT_ADMINISTRATION,
        defaultHref: TabConstants.BLOOD_PRODUCT_ADMINISTRATION_PROCEDURE,
        date: dateTime,
      }
      if (index !== -1) {
        items[index] = item
      } else {
        items.push(item)
      }
      yield put(setActivityLog(items))
      yield put(saveTimelineItems())
    }
  } catch (e) {
    yield put(throwPcrException(`addBloodProductAdministrationItemSaga() error: ${e}`))
  }
}

export function* addBloodProductAdministrationItemSaga() {
  yield takeLatest(
    [TimelineConstants.ADD_BLOOD_PRODUCT_ADMINISTRATION],
    performWithMutexHOG,
    addBloodProductAdministrationItem
  )
}
